import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faVolumeHigh } from '@fortawesome/free-solid-svg-icons';
import { playWord } from '../utils/speechService';

/**
 * 单词播放组件
 * 提供一个统一的单词播放按钮，可在多个页面中复用
 */
const WordPlayer = ({ 
  word, 
  className = '', 
  iconClassName = 'text-blue-500',
  options = {} 
}) => {
  const handlePlayWord = () => {
    playWord(word, options);
  };

  return (
    <button 
      className={`w-8 h-8 rounded-full bg-blue-100 flex items-center justify-center ${className}`}
      onClick={handlePlayWord}
      aria-label={`播放单词 ${word}`}
    >
      <FontAwesomeIcon icon={faVolumeHigh} className={iconClassName} />
    </button>
  );
};

export default WordPlayer;